import { RESET_STATE } from "../constants/actionTypes";

export function resetState() {
  return {
    type: RESET_STATE,
  };
}
